const _auto = "auto"
const _cover = "cover"
const _contain = "contain"
const config = { "auto": _auto, "cover": _cover, "contain": _contain,  }
export { config as default, _auto, _cover, _contain }